export const AUTH_ROUTE_IDS = {
  ROOT: 'dashboard',
  LOGIN: 'login',
  LOGOUT: 'logout',
  TWO_FACTOR: 'twoFactor',
  INITIAL_PASSWORD: 'initialPassword',
  CHANGE_PASSWORD: 'changePassword',
  RESET_PASSWORD: 'resetPassword',
} as const;

export const LOCALIZED_AUTH_ROUTES: Record<string, Record<string, string>> = {
  [AUTH_ROUTE_IDS.ROOT]: {
    de: 'auth',
    fr: 'auth',
    it: 'auth',
    en: 'auth',
  },
  [AUTH_ROUTE_IDS.LOGIN]: {
    de: 'login',
    fr: 'login',
    it: 'login',
    en: 'login',
  },
  [AUTH_ROUTE_IDS.LOGOUT]: {
    de: 'logout',
    fr: 'logout',
    it: 'logout',
    en: 'logout',
  },
  [AUTH_ROUTE_IDS.TWO_FACTOR]: {
    de: 'zwei-faktor',
    fr: 'deux-factor',
    it: 'due-fattori',
    en: 'two-factor',
  },
  [AUTH_ROUTE_IDS.INITIAL_PASSWORD]: {
    de: 'initiales-passwort',
    fr: 'initial-password',
    it: 'iniziale-password',
    en: 'initial-password',
  },
  [AUTH_ROUTE_IDS.CHANGE_PASSWORD]: {
    de: 'passwort-aendern',
    fr: 'changer-mdp',
    it: 'cambia-password',
    en: 'password-change',
  },
  [AUTH_ROUTE_IDS.RESET_PASSWORD]: {
    de: 'passwort-reset',
    fr: 'reset-mdp',
    it: 'reset-password',
    en: 'password-reset',
  },
};
